/*
  This is the main file for the client Svelte app.  Usually you wouldn't need to
  modify this unless you want to alter the Svelte configuration or add some
  necessary code.
 */
import App from '$/client/App.svelte';

const app = new App({
	target: document.body,
	props: {

	}
});

export default app;
